module.exports = __webpack_public_path__ + "img/bgEmpresa.877b952f.png";